import React, { Component } from 'react';
import styled from 'styled-components';

import { colors } from '../../styles/colors';
import Icon from '../Icon';

import logo from '../../images/azul-logo-color@2x.png';
import logoTudoAzul from '../../images/logo-tudoazul-white@2x.png';

const HeaderWrapper = styled.header`
  display: flex;
  padding: 0 8px;
  color: white;
  height: 60px;
  background-color: ${colors.BRAND_SECONDARY};
  justify-content: space-between;
  align-items: center;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;

  & img {
    max-width: 105px;
  }
`;

const UserContainer = styled.div`
  display: flex;
  width: 124px;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${colors.BRAND_LIGHTER};
  border-radius: 2px;
  height: 48px;
  padding: 6px;

  & img {
    max-width: 75px;
    height: auto;
  }
`;

const UserIcon = styled(Icon)`
  color: ${colors.BRAND_LIGHTER};
  font-size: 32px;
  width: 30px;
`;

class Header extends Component {
  render() {
    return (
      <HeaderWrapper>
        <LogoContainer>
          <img src={logo} alt="Azul Linhas Aéreas" />
        </LogoContainer>
        <UserContainer>
          <img src={logoTudoAzul} alt="TudoAzul" height="auto" />
          <UserIcon name="user" />
        </UserContainer>
      </HeaderWrapper>
    );
  }
}

export default Header;
